import { render, staticRenderFns } from "./travel-table.vue?vue&type=template&id=21b9f8de&scoped=true&"
import script from "./travel-table.vue?vue&type=script&lang=js&"
export * from "./travel-table.vue?vue&type=script&lang=js&"
import style0 from "./travel-table.vue?vue&type=style&index=0&id=21b9f8de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9f8de",
  null
  
)

export default component.exports